export const BOOLEAN_OPTIONS = {
  ALL: "",
  YES: true,
  NO: false,
};

export const booleanOptionLabels = () => ({
  [BOOLEAN_OPTIONS.YES]: "Yes",
  [BOOLEAN_OPTIONS.NO]: "No",
});

export const booleanOptionIconLabels = () => ({
  [BOOLEAN_OPTIONS.YES]: "✅",
  [BOOLEAN_OPTIONS.NO]: "❌",
});

export const booleanOptionFormOptions = () => [
  {
    value: BOOLEAN_OPTIONS.YES,
    label: booleanOptionLabels()[BOOLEAN_OPTIONS.YES],
  },
  {
    value: BOOLEAN_OPTIONS.NO,
    label: booleanOptionLabels()[BOOLEAN_OPTIONS.NO],
  },
];

export const booleanOptionFilters = () => [
  { value: BOOLEAN_OPTIONS.ALL, label: "All" },
  {
    value: BOOLEAN_OPTIONS.YES.toString(),
    label: booleanOptionLabels()[BOOLEAN_OPTIONS.YES],
  },
  {
    value: BOOLEAN_OPTIONS.NO.toString(),
    label: booleanOptionLabels()[BOOLEAN_OPTIONS.NO],
  },
];
